document.addEventListener('DOMContentLoaded', () => {
  const productsOnPage = document.querySelector('.grid.product-grid');
  let nextUrl = productsOnPage.dataset.nextUrl;
  let prevUrl = productsOnPage.dataset.prevUrl;
  const loadMoreBtn = document.querySelector('.load-more-btn');
  const loadPrevBtn = document.querySelector('.load-prev-btn');

  loadMoreBtn.addEventListener('click', async (e) => {
    await updateProducts(e, nextUrl, 'beforeend');
    if (!nextUrl) {
      loadMoreBtn.classList.add('hidden');
      document.querySelector('.of-products').classList.toggle('hidden');
    }
  });

  loadPrevBtn.addEventListener('click', async (e) => {
    await updateProducts(e, prevUrl, 'afterbegin');
    if (!prevUrl) {
      loadPrevBtn.classList.add('hidden');
    }
  });

  async function updateProducts(event, url, position) {
    event.preventDefault();
    const spinner = event.target.querySelector('.loading__spinner');

    spinner.classList.toggle('hidden');
    const response = await fetch(url);
    const textHtml = await response.text();

    const parser = new DOMParser();
    const newProducts = parser.parseFromString(textHtml, 'text/html').querySelector('.grid.product-grid');

    productsOnPage.insertAdjacentHTML(position, newProducts.innerHTML);
    window.history.pushState({}, '', url);
    if (position === 'beforeend') {
      nextUrl = newProducts.dataset.nextUrl;
    } else {
      prevUrl = newProducts.dataset.prevUrl;
    }
    spinner.classList.toggle('hidden');
    document.querySelector('.of-products .current-products-number').innerText =
      productsOnPage.querySelectorAll('li.grid__item').length;

   // Update product count
  document.querySelector('.of-products .current-products-number').innerText =
    productsOnPage.querySelectorAll('li.grid__item').length;

  console.log("New products added. Dispatching swym:collections-loaded event...");
  document.dispatchEvent(new CustomEvent("swym:collections-loaded"));

  }
});
